<template>
    <app-layout title="Aanvragen">
        <template #header>
            <page-title :title="title" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm">
                <div class="mt-4">
                    <div class="border-b-[1px] border-blue-dark-500 pb-4 mb-4">
                        <h2>Algemene informatie</h2>
                        <div class="w-4/6 grid grid-cols-2 gap-6">
                            <div>
                                <Input
                                    type="text"
                                    label="Bestelbon referentie"
                                    name="reference"
                                    :required="true"
                                    v-model="form.reference"
                                    :error="form.errors.reference"
                                    layout="vertical"
                                />
                                <Select
                                    label="Opdracht"
                                    name="assignment_type_id"
                                    :required="true"
                                    :options="assignmentTypeOptions"
                                    v-model="form.assignment_type_id"
                                    :error="form.errors.assignment_type_id"
                                    layout="vertical"
                                    :key="form.request_type_id"
                                />
                                <Select
                                    label="Oppervlakte categorie"
                                    name="surface_id"
                                    :options="surfaceOptions"
                                    :emptyOption="true"
                                    :sortByLabel="false"
                                    v-model="form.surface_id"
                                    :error="form.errors.surface_id"
                                    layout="vertical"
                                    v-if="productAttributes.some(attr => attr.assignment_type_id === parseInt(form.assignment_type_id) && attr.type === 'surface')"
                                />
                                <Input
                                    type="number"
                                    label="Oppervlakte (m²)"
                                    name="surface_area"
                                    v-model="form.surface_area"
                                    :error="form.errors.surface_area"
                                    layout="vertical"
                                    v-if="productAttributes.some(attr => attr.assignment_type_id === parseInt(form.assignment_type_id) && attr.type === 'surface')"
                                />
                                <Input
                                    type="number"
                                    label="Aantal wooneenheden"
                                    name="residences"
                                    v-model="form.residences"
                                    :error="form.errors.residences"
                                    layout="vertical"
                                    v-if="productAttributes.some(attr => attr.assignment_type_id === parseInt(form.assignment_type_id) && attr.type === 'residences')"
                                />
                                <Input
                                    label="Urgent"
                                    name="urgent"
                                    id="urgent"
                                    type="checkbox"
                                    :checked="form.urgent"
                                    value="1"
                                    v-model="form.urgent"
                                />
                                <Textarea
                                    label="Info"
                                    name="info"
                                    v-model="form.info"
                                    :error="form.errors.info"
                                    layout="vertical"
                                />
                            </div>
                            <div>
                                <Input
                                    type="text"
                                    label="Klant"
                                    name="customer"
                                    :required="true"
                                    v-model="form.customer"
                                    :error="form.errors.customer"
                                    layout="vertical"
                                />
                                <Input
                                    type="email"
                                    label="Contactpersoon (mail)"
                                    name="mail_contact"
                                    :required="true"
                                    v-model="form.mail_contact"
                                    :error="form.errors.mail_contact"
                                    layout="vertical"
                                />
                                <Input
                                    type="date"
                                    label="Aangevraagd op"
                                    name="requested_at"
                                    :required="requestTypeOptions[form.request_type_id] && !requestTypeOptions[form.request_type_id].includes('Offerte')"
                                    v-model="form.requested_at"
                                    :error="form.errors.requested_at"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Dossiernummer"
                                    name="external_reference"
                                    :required="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop Dewaele')"
                                    v-model="form.external_reference"
                                    :error="form.errors.external_reference"
                                    layout="vertical"
                                    v-if="requestTypeOptions[form.request_type_id] && (requestTypeOptions[form.request_type_id].includes('Webshop Dewaele')
                                        || requestTypeOptions[form.request_type_id].includes('Offerte') || requestTypeOptions[form.request_type_id].includes('Bestek'))"
                                />
                                <Select
                                    label="Bestek"
                                    name="estimate_id"
                                    :options="estimateOptions"
                                    :required="true"
                                    v-model="form.estimate_id"
                                    :error="form.errors.estimate_id"
                                    layout="vertical"
                                    v-if="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Bestek')"
                                />
                                <div class="flex justify-between">
                                    <Input
                                        type="date"
                                        label="Voorkeursdatum"
                                        name="preference_date"
                                        v-model="form.preference_date"
                                        :error="form.errors.preference_date"
                                        layout="vertical"
                                        class="w-1/2 mr-2"
                                    />
                                    <Input
                                        type="time"
                                        label="Voorkeurstijd"
                                        name="preference_time"
                                        :step="900"
                                        v-model="form.preference_time"
                                        :error="form.errors.preference_time"
                                        layout="vertical"
                                        class="w-1/2 ml-2"
                                    />
                                </div>
                                <Input
                                    type="text"
                                    label="Makelaar"
                                    name="broker_person"
                                    v-model="form.broker_person"
                                    :error="form.errors.broker_person"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Telefoon makelaar"
                                    name="broker_phone"
                                    v-model="form.broker_phone"
                                    :error="form.errors.broker_phone"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Mail makelaar"
                                    name="broker_mail"
                                    v-model="form.broker_mail"
                                    :error="form.errors.broker_mail"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Kantoor makelaar"
                                    name="broker_company"
                                    v-model="form.broker_company"
                                    :error="form.errors.broker_company"
                                    layout="vertical"
                                />

                            </div>
                        </div>
                    </div>
                    <div class="border-b-[1px] border-blue-dark-500 pb-4 mb-4">
                        <h2>Inspectie adres</h2>
                        <div class="w-4/6 grid grid-cols-2 gap-6">
                            <div>
                                <Input
                                    type="text"
                                    label="Naam"
                                    name="inspection_name"
                                    :required="true"
                                    v-model="form.inspection_name"
                                    :error="form.errors.inspection_name"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Straat + nr"
                                    name="inspection_address"
                                    :required="true"
                                    v-model="form.inspection_address"
                                    :error="form.errors.inspection_address"
                                    layout="vertical"
                                />
<!--                                Postal code not required when editing, we don't always get the postal code from the webshop.  So asbest doesn't need to look for it.-->
                                <Input
                                    type="text"
                                    label="Postcode"
                                    name="inspection_postal_code"
                                    :required="form.request_id === null"
                                    v-model="form.inspection_postal_code"
                                    :error="form.errors.inspection_postal_code"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Plaats"
                                    name="inspection_place"
                                    :required="true"
                                    v-model="form.inspection_place"
                                    :error="form.errors.inspection_place"
                                    layout="vertical"
                                />
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>
                    <div class=" pb-4 mb-4">
                        <h2>Facturatie info</h2>
                        <Input
                            label="Zelfde adres als inspectieadres"
                            name="same_address"
                            id="same_address"
                            type="checkbox"
                            :checked="form.same_address"
                            value="1"
                            v-model="form.same_address"
                            @change="sameAddress"
                        />
                        <div class="w-4/6 grid grid-cols-2 gap-6">
                            <div>
                                <Input
                                    type="text"
                                    label="Naam"
                                    name="invoice_customer_name"
                                    :required="(requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop')) || (request && request.invoice_customer_id !== null)"
                                    v-model="form.invoice_customer_name"
                                    :error="form.errors.invoice_customer_name"
                                    layout="vertical"
                                    :disabled="Boolean(form.same_address)"
                                />
                                <Input
                                    type="text"
                                    label="Bedrijf"
                                    name="invoice_customer_company"
                                    v-model="form.invoice_customer_company"
                                    :error="form.errors.invoice_customer_company"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="BTW nummer"
                                    name="invoice_customer_vat_number"
                                    v-model="form.invoice_customer_vat_number"
                                    :error="form.errors.invoice_customer_vat_number"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Straat + nr"
                                    name="invoice_customer_address"
                                    :required="(requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop'))
                                        || (request && request.invoice_customer_id !== null)"
                                    v-model="form.invoice_customer_address"
                                    :error="form.errors.invoice_customer_address"
                                    layout="vertical"
                                    :disabled="Boolean(form.same_address)"
                                />
<!--                            Postal code not required when editing, we don't always get the postal code from the webshop.  So asbest doesn't need to look for it.-->
                                <Input
                                    type="text"
                                    label="Postcode"
                                    name="invoice_customer_postal_code"
                                    :required="(form.request_id === null && requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop'))
                                        || (form.request_id === null && request && request.invoice_customer_id !== null)"
                                    max="9999"
                                    v-model="form.invoice_customer_postal_code"
                                    :error="form.errors.invoice_customer_postal_code"
                                    layout="vertical"
                                    :disabled="Boolean(form.same_address)"
                                />
                                <Input
                                    type="text"
                                    label="Plaats"
                                    name="invoice_customer_place"
                                    :required="(requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop')) || (request && request.invoice_customer_id !== null)"
                                    v-model="form.invoice_customer_place"
                                    :error="form.errors.invoice_customer_place"
                                    layout="vertical"
                                    :disabled="Boolean(form.same_address)"
                                />
                                <Input
                                    type="text"
                                    label="Landcode"
                                    name="invoice_customer_country_code"
                                    :required="(requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop')) || (request && request.invoice_customer_id !== null)"
                                    v-model="form.invoice_customer_country_code"
                                    :error="form.errors.invoice_customer_country_code"
                                    layout="vertical"
                                />
                            </div>
                            <div>
                                <Input
                                    type="text"
                                    label="Email"
                                    name="invoice_customer_email"
                                    v-model="form.invoice_customer_email"
                                    :error="form.errors.invoice_customer_email"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Telefoon"
                                    name="invoice_customer_phone"
                                    v-model="form.invoice_customer_phone"
                                    :error="form.errors.invoice_customer_phone"
                                    layout="vertical"
                                />
                                <Input
                                    type="text"
                                    label="Factuurnummer"
                                    name="invoice_number"
                                    :required="(requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop'))"
                                    v-model="form.invoice_number"
                                    :error="form.errors.invoice_number"
                                    layout="vertical"
                                    :disabled="Boolean(form.same_address) && requestTypeOptions[form.request_type_id].includes('Webshop')"
                                />
                                <Input
                                    type="double"
                                    label="Facturatiebedrag"
                                    name="invoice_amount"
                                    :required="(requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop'))"
                                    v-model="form.invoice_amount"
                                    :error="form.errors.invoice_amount"
                                    layout="vertical"
                                />
                                <Input
                                    type="date"
                                    label="Datum betaling"
                                    name="invoice_paid_at"
                                    v-model="form.invoice_paid_at"
                                    :error="form.errors.invoice_paid_at"
                                    layout="vertical"
                                />
                                <Textarea
                                    label="Info"
                                    name="invoice_info"
                                    v-model="form.invoice_info"
                                    :error="form.errors.invoice_info"
                                    layout="vertical"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="w-4/6 flex justify-end">
                        <Button
                            htmlType="a"
                            buttonClass="secondary"
                            text="Annuleren"
                            :href="route('requests.detail',  {'id': request.id})"
                            v-if="request !== null"
                        />
                        <Button
                            buttonClass="save"
                            title="Opslaan"
                            text="Opslaan"
                            type="submit"
                            :loading="form.processing"
                        />
                    </div>
                </div>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'
import Textarea from '@/Components/Textarea.vue'

import Cancel from '@/Components/Requests/Cancel.vue'

import store from '@/store'
import { useForm } from '@inertiajs/inertia-vue3'
import { ref } from 'vue'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        Form,
        Input,
        Select,
        Textarea,
        Cancel,
    },
    props: [
        'title',
        'request',
        'requestTypes',
        'requestDuedates',
        'productAttributes',
        'surfaces',
        'estimates',
        'requestTypeId',
        'invoiceNumber',
        'invoicePaidAt',
        'estimateId',
    ],
    setup (props)
    {
        let requestTypeOptions = {}
        let assignmentTypeOptions = ref({})
        let estimateOptions = {}
        let surfaceOptions = {}

        props.requestTypes.forEach(function(requestType) {
            requestTypeOptions[requestType.id] = requestType.type
        })

        props.estimates.forEach(function(estimate) {
            estimateOptions[estimate.id] = estimate.name
        })

        props.surfaces.forEach(function(surface) {
            surfaceOptions[surface.id] = new DOMParser().parseFromString(surface.size, "text/html").documentElement.textContent;
        })

        const form = useForm({
            request_id: (props.request !== null) ? props.request.id : null,
            reference: (props.request !== null) ? props.request.reference : props.invoiceNumber,//Same as invoice_number
            urgent: (props.request !== null) ? Boolean(props.request.urgent) : false,
            info: (props.request !== null) ? props.request.info : null,
            customer: (props.request !== null) ? props.request.customer : null,
            mail_contact: (props.request !== null) ? props.request.mail_contact : null,
            requested_at: (props.request !== null) ? props.request.requested_at : props.invoicePaidAt,//same as invoice_paid_at
            status: (props.request !== null) ? props.request.status : null,
            external_reference: (props.request !== null) ? props.request.external_reference : null,
            external_id: (props.request !== null) ? props.request.external_id : null,
            preference_date: (props.request !== null) ? props.request.preference_date : null,
            preference_time: (props.request !== null) ? props.request.preference_time : null,
            import_id: (props.request !== null) ? props.request.import_id : null,
            assignment_type_id: (props.request !== null) ? props.request.assignment_type_id : null,
            request_type_id: (props.request !== null) ? props.request.request_type_id : props.requestTypeId,
            estimate_id: (props.request !== null) ? props.request.estimate_id : props.estimateId,
            surface_id: (props.request !== null) ? props.request.surface_id : null,
            surface_area: (props.request !== null) ? props.request.surface_area : null,
            residences: (props.request !== null) ? props.request.residences : null,
            invoice_customer_id: (props.request !== null) ? props.request.invoice_customer_id : null,
            assignment_id: (props.request !== null) ? props.request.assignment_id : null,
            quote_id: (props.request !== null) ? props.request.quote_id : null,
            inspection_address_id: (props.request !== null) ? props.request.inspection_address_id : null,
            inspection_name: (props.request !== null) ? props.request.inspection_address.name : null,
            inspection_address: (props.request !== null) ? props.request.inspection_address.address : null,
            inspection_address_info: (props.request !== null) ? props.request.inspection_address.address_info : null,
            inspection_postal_code: (props.request !== null) ? props.request.inspection_address.postal_code : null,
            inspection_place: (props.request !== null) ? props.request.inspection_address.place : null,
            same_address: false, //for inspection address = invoice customer address
            invoice_customer_name: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.name : null,
            invoice_customer_company: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.company : null,
            invoice_customer_address: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.address : null,
            invoice_customer_address_info: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.address_info : null,
            invoice_customer_place: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.place : null,
            invoice_customer_postal_code: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.postal_code : null,
            invoice_customer_country_code: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.country_code : "BE",
            invoice_customer_vat_number: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.vat_number : null,
            invoice_customer_email: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.email : null,
            invoice_customer_phone: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.phone : null,
            invoice_number: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.number : props.invoiceNumber,
            invoice_paid_at: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.paid_at : props.invoicePaidAt,
            invoice_amount: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.amount : null,
            invoice_info: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.info : null,
            partner_id: (props.request !== null) ? props.request.partner_id : null,
            broker_id: (props.request !== null) ? props.request.broker_id : null,
            broker_person: (props.request !== null && props.request.broker !== null) ? props.request.broker.person : null,
            broker_mail: (props.request !== null && props.request.broker !== null) ? props.request.broker.mail : null,
            broker_phone: (props.request !== null && props.request.broker !== null) ? props.request.broker.phone : null,
            broker_company: (props.request !== null && props.request.broker !== null) ? props.request.broker.company : null,
        })

        setAssignmentOptions(props.requestTypeId)

        function setAssignmentOptions(requestTypeId)
        {
            assignmentTypeOptions.value = {}
            requestTypeId = requestTypeId ?? form.request_type_id

            props.requestDuedates.forEach(function(requestDuedate) {

                if (parseInt(requestDuedate.request_type_id) === parseInt(requestTypeId))
                {
                    assignmentTypeOptions.value[requestDuedate.assignment_type.id] = requestDuedate.assignment_type.name
                }
            })
        }

        function sameAddress()
        {
            if (Boolean(form.same_address))
            {
                form.invoice_customer_name = form.inspection_name
                form.invoice_customer_address = form.inspection_address
                form.invoice_customer_place = form.inspection_place
                form.invoice_customer_postal_code = form.inspection_postal_code

                if (requestTypeOptions[form.request_type_id].includes('Webshop'))
                {
                    form.invoice_number = form.reference
                }
            }
        }

        function postForm()
        {
            form.post(route('requests.store'))
        }

        return {
            state: store.state,
            ...store,
            requestTypeOptions,
            assignmentTypeOptions,
            estimateOptions,
            surfaceOptions,
            setAssignmentOptions,
            form,
            postForm,
            sameAddress,
        }
    },
}

</script>
